import { render, staticRenderFns } from "./MsgSeverPhone.vue?vue&type=template&id=aff53096&scoped=true"
import script from "./MsgSeverPhone.vue?vue&type=script&lang=js"
export * from "./MsgSeverPhone.vue?vue&type=script&lang=js"
import style0 from "./MsgSeverPhone.vue?vue&type=style&index=0&id=aff53096&prod&lang=scss&scoped=true"
import style1 from "./MsgSeverPhone.vue?vue&type=style&index=1&id=aff53096&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_7d198ec714527f3eb87755d9f59e0144/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff53096",
  null
  
)

export default component.exports